/* Variant data is resolved by Shopify on each selection, including price, media and availability. */
document.addEventListener('change',function(event){
  if(!event.target.matches('[data-product-option]'))return;
  var section=event.target.closest('[data-product-section]');
  var ids=Array.from(section.querySelectorAll('[data-product-option]'),function(select){return select.value;});
  if(ids.some(function(value){return !value;}))return;
  var destination=new URL(window.location.href);
  destination.searchParams.delete('variant');
  destination.searchParams.set('option_values',ids.join(','));
  window.location.assign(destination.toString());
});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(function(menu){menu.open=false;});}});


/* Return through the same light, locally or across a shop-page navigation. */
(() => {
  const root = document.documentElement;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const content = document.getElementById('StoreContent');
  let veil;
  let returnTimer;
  let returning = false;
  let destinationEntrance;

  const clearReturn = () => {
    clearTimeout(returnTimer);
    veil?.remove();
    veil = null;
    returning = false;
    destinationEntrance = null;
    content?.classList.remove('nd-shop-returning');
  };
  const clearIncoming = () => {
    clearTimeout(window.ndReturnCoverFallback);
    clearTimeout(incomingTimer);
    root.classList.remove('nd-return-cover', 'nd-return-uncover');
    const url = new URL(window.location.href);
    if (url.searchParams.has('light_return')) {
      url.searchParams.delete('light_return');
      window.history.replaceState(window.history.state, '', url);
    }
  };
  let incomingTimer;
  if (root.classList.contains('nd-return-cover')) {
    if (reducedMotion.matches) {
      clearIncoming();
    } else {
      const riverImage = document.querySelector('.nd-river-image');
      const imageReady = riverImage?.decode ? riverImage.decode().catch(() => {}) : Promise.resolve();
      Promise.all([customElements.whenDefined('nd-store-entrance'), imageReady]).then(() => {
        if (!root.classList.contains('nd-return-cover')) return;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          root.classList.add('nd-return-uncover');
          incomingTimer = setTimeout(clearIncoming, 3250);
          document.querySelector('nd-store-entrance')?.focus({ preventScroll: true });
        }));
      });
    }
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-open-entrance]');
    if (!link || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        reducedMotion.matches) return;
    event.preventDefault();
    if (returning) return;
    returning = true;
    const entrance = document.querySelector('nd-store-entrance');
    destinationEntrance = typeof entrance?.reopen === 'function' ? entrance : null;
    destinationEntrance?.clearArrival();
    veil = document.createElement('div');
    veil.className = 'nd-return-glow';
    veil.setAttribute('aria-hidden', 'true');
    document.body.append(veil);
    content?.classList.add('nd-shop-returning');
    returnTimer = setTimeout(() => {
      if (destinationEntrance) {
        // Switch scenes only when the warm light is fully opaque.
        destinationEntrance.reopen();
        content?.classList.remove('nd-shop-returning');
        veil.classList.add('is-revealing');
        returnTimer = setTimeout(clearReturn, 3250);
      } else {
        const destination = new URL(link.href);
        destination.searchParams.set('light_return', '1');
        window.location.assign(destination.href);
        // Restore a usable shop if a navigation is interrupted or fails.
        returnTimer = setTimeout(clearReturn, 8000);
      }
    }, 1450);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (returning) {
      event.preventDefault();
      event.stopImmediatePropagation();
      destinationEntrance?.reopen();
      clearReturn();
    } else if (root.classList.contains('nd-return-cover')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clearIncoming();
    }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      clearReturn();
      clearIncoming();
    }
  });
})();

/* Separate boutique pages, with a soft parchment fade across native navigation. */
(() => {
  const root = document.documentElement;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'nd-page-fade';
  let leaving = false;
  let navigateTimer;
  let resetTimer;
  const reset = () => {
    clearTimeout(navigateTimer);
    clearTimeout(resetTimer);
    clearTimeout(window.ndPageCoverFallback);
    root.classList.remove('nd-page-cover', 'nd-page-reveal', 'nd-page-leaving', 'nd-entrance-arrival');
    leaving = false;
    try { sessionStorage.removeItem(key); } catch (_) { /* Storage may be unavailable. */ }
  };
  if (root.classList.contains('nd-page-cover')) {
    if (motion.matches) reset();
    else {
      const images = [...document.querySelectorAll('main img')].slice(0, 3);
      const imageReady = Promise.all(images.map(image => image.decode ? image.decode().catch(() => {}) : Promise.resolve()));
      const fontReady = document.fonts?.ready || Promise.resolve();
      const entranceArrival = root.classList.contains('nd-entrance-arrival');
      Promise.race([Promise.all([imageReady, fontReady]), new Promise(resolve => setTimeout(resolve, 2200))]).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          root.classList.add('nd-page-reveal');
          resetTimer = setTimeout(reset, entranceArrival ? 2550 : 950);
        }));
      });
    }
  }
  const menu = document.querySelector('.mobile-menu');
  const menuToggle = menu?.querySelector('summary');
  menu?.addEventListener('toggle', () => {
    menuToggle.setAttribute('aria-label', menu.open ? 'Close navigation' : 'Open navigation');
  });
  document.addEventListener('click', event => {
    if (menu?.open && !menu.contains(event.target)) menu.open = false;
    const link = event.target.closest('a[data-soft-nav]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin) return;
    if (menu?.contains(link)) menu.open = false;
    if (motion.matches || (destination.pathname === location.pathname && destination.search === location.search)) return;
    if (window.NoelDrewShop?.canHandle(destination)) {
      event.preventDefault();
      window.NoelDrewShop.navigate(destination);
      return;
    }
    event.preventDefault();
    if (leaving) return;
    leaving = true;
    root.classList.add('nd-page-leaving');
    navigateTimer = setTimeout(() => {
      try { sessionStorage.setItem(key, JSON.stringify({path:destination.pathname + destination.search, time:Date.now()})); } catch (_) { /* Native navigation still works. */ }
      location.assign(destination.href);
      resetTimer = setTimeout(reset, 6500);
    }, 420);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && (leaving || root.classList.contains('nd-page-cover'))) reset();
    if (event.key === 'Escape' && menu?.contains(document.activeElement)) menuToggle.focus();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) reset(); });
})();

/* Native touch scrolling and scroll snapping, enhanced with mouse drag, arrows and keyboard. */
(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const setup = root => {
    if (root.hasAttribute('data-orbit-gallery')) return;
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const track = root.querySelector('[data-gallery-track]');
    const cards = [...track.querySelectorAll('.product-card')];
    const controls = root.querySelector('[data-gallery-controls]');
    if (!cards.length) return;
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const status = root.querySelector('[data-gallery-status]');
    let index = 0;
    let scrollTimer;
    let drag;
    let dragged = false;
    controls.hidden = cards.length < 2;
    cards.forEach((card, i) => { card.setAttribute('role', 'group'); card.setAttribute('aria-roledescription', 'slide'); card.setAttribute('aria-label', `${i + 1} of ${cards.length}`); });
    const update = () => {
      const center = track.getBoundingClientRect().left + track.clientWidth / 2;
      let nearest = Infinity;
      cards.forEach((card, i) => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < nearest) { nearest = distance; index = i; }
      });
      status.textContent = `${index + 1} / ${cards.length}`;
      previous.disabled = index === 0;
      next.disabled = index === cards.length - 1;
    };
    const go = target => {
      index = Math.max(0, Math.min(cards.length - 1, target));
      const card = cards[index].getBoundingClientRect();
      const bounds = track.getBoundingClientRect();
      track.scrollTo({left:track.scrollLeft + card.left - bounds.left - (track.clientWidth - card.width) / 2, behavior:motion.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => go(index - 1));
    next.addEventListener('click', () => go(index + 1));
    track.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(update, 100); }, {passive:true});
    track.addEventListener('scrollend', update);
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track.addEventListener('dragstart', event => event.preventDefault());
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:track.scrollLeft};
      dragged = false;
    });
    track.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = event.clientX - drag.x;
      if (!dragged && Math.abs(distance) < 7) return;
      if (!dragged && Math.abs(event.clientY - drag.y) > Math.abs(distance)) { drag = null; return; }
      dragged = true;
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
      track.scrollLeft = drag.left - distance;
    });
    const endDrag = event => {
      if (!drag || event.pointerId !== drag.id) return;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      drag = null;
      track.classList.remove('is-dragging');
      if (dragged) { update(); go(index); setTimeout(() => { dragged = false; }, 0); }
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); } }, true);
    new ResizeObserver(update).observe(track);
    update();
  };
  document.querySelectorAll('[data-jewelry-gallery]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jewelry-gallery]').forEach(setup));
})();

/* Broad cloud layers drift independently; the original photograph remains the fallback. */
(() => {
  if (customElements.get('nd-boutique-clouds')) return;
  const pauseKey = 'noel-drew-clouds-paused-v1';
  const frameInterval = 1000 / 24;

  class BoutiqueClouds extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.content = this.closest('#StoreContent');
      this.image = this.querySelector('.nd-home-cloud-image');
      this.canvas = this.querySelector('.nd-home-cloud-canvas');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.buttons = Array.from(this.content?.querySelectorAll('[data-cloud-toggle]') || []);
      this.intersecting = true;
      this.time = 0;
      this.frameCount = 0;
      this.lastFrame = 0;
      this.userPaused = false;
      this.imageFailed = false;
      this.cloudLayer = null;
      try { this.userPaused = sessionStorage.getItem(pauseKey) === 'yes'; } catch (_) { /* Optional storage. */ }
      try { this.context = this.canvas?.getContext('2d', { alpha: false }); } catch (_) { this.context = null; }
      this.classList.remove('is-ready');
      this.dataset.cloudFrame = '0';

      for (const button of this.buttons) {
        button.addEventListener('click', () => {
          if (this.motion.matches) return;
          this.userPaused = !this.userPaused;
          try { sessionStorage.setItem(pauseKey, this.userPaused ? 'yes' : 'no'); } catch (_) { /* Optional storage. */ }
          this.sync();
        }, options);
      }
      this.motion.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      window.addEventListener('pagehide', () => this.stop(), options);
      window.addEventListener('pageshow', () => this.sync(), options);

      this.visibilityObserver?.disconnect();
      if (this.content) {
        this.visibilityObserver = new MutationObserver(() => {
          if (!this.content.hidden) this.resize();
          this.sync();
        });
        this.visibilityObserver.observe(this.content, { attributes: true, attributeFilter: ['hidden'] });
      }
      this.intersectionObserver?.disconnect();
      this.intersectionObserver = new IntersectionObserver(entries => {
        this.intersecting = entries.some(entry => entry.isIntersecting);
        if (this.intersecting) this.resize();
        this.sync();
      });
      this.intersectionObserver.observe(this);
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => {
        this.resize();
        this.sync();
      });
      this.resizeObserver.observe(this);

      this.image?.addEventListener('load', () => {
        this.imageFailed = false;
        this.cloudLayer = null;
        this.resize();
        this.sync();
      }, options);
      this.image?.addEventListener('error', () => {
        this.imageFailed = true;
        this.classList.remove('is-ready');
        this.sync();
      }, options);
      this.tick = now => {
        this.frame = 0;
        if (!this.canRun()) { this.sync(); return; }
        const elapsed = now - this.lastFrame;
        if (elapsed >= frameInterval) {
          this.time += Math.min(elapsed, 100) / 1000;
          this.lastFrame = now - (elapsed % frameInterval);
          this.draw();
        }
        this.frame = requestAnimationFrame(this.tick);
      };
      this.resize();
      this.sync();
    }

    isReady() {
      return Boolean(this.context && !this.imageFailed && this.image?.complete
        && this.image.naturalWidth && this.canvas.width && this.canvas.height);
    }

    canRun() {
      return this.isConnected && this.isReady() && this.intersecting
        && !this.content?.hidden && !document.hidden && !this.userPaused && !this.motion.matches;
    }

    resize() {
      if (!this.context || this.content?.hidden || !this.isConnected) return;
      const rect = this.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const scale = Math.min(window.devicePixelRatio || 1, 1.5,
        1600 / Math.max(rect.width, rect.height));
      const width = Math.max(1, Math.round(rect.width * scale));
      const height = Math.max(1, Math.round(rect.height * scale));
      if (this.canvas.width !== width || this.canvas.height !== height) {
        this.canvas.width = width;
        this.canvas.height = height;
        this.cloudLayer = null;
      }
      this.draw();
    }

    cover(context, source, width, height, zoom = 1, x = 0, y = 0) {
      const sourceWidth = source.naturalWidth || source.width;
      const sourceHeight = source.naturalHeight || source.height;
      const scale = Math.max(width / sourceWidth, height / sourceHeight) * zoom;
      const paintedWidth = sourceWidth * scale;
      const paintedHeight = sourceHeight * scale;
      context.drawImage(source, (width - paintedWidth) / 2 + x,
        (height - paintedHeight) / 2 + y, paintedWidth, paintedHeight);
    }

    prepareCloudLayer() {
      const { width, height } = this.canvas;
      const layer = document.createElement('canvas');
      layer.width = width;
      layer.height = height;
      const context = layer.getContext('2d');
      if (!context) return null;
      this.cover(context, this.image, width, height, 1.16);
      // A feathered, broad cloud bank creates parallax without breaking the image into bands.
      context.globalCompositeOperation = 'destination-in';
      context.save();
      context.translate(width * .38, height * .60);
      context.scale(width * .72, height * .65);
      const mask = context.createRadialGradient(0, 0, .1, 0, 0, 1);
      mask.addColorStop(0, 'rgba(255,255,255,.85)');
      mask.addColorStop(.45, 'rgba(255,255,255,.6)');
      mask.addColorStop(1, 'rgba(255,255,255,0)');
      context.fillStyle = mask;
      context.fillRect(-2, -2, 4, 4);
      context.restore();
      return layer;
    }

    drawMist(x, y, radius, opacity, stretch) {
      const context = this.context;
      context.save();
      context.translate(x, y);
      context.scale(stretch, 1);
      const mist = context.createRadialGradient(0, 0, 0, 0, 0, radius);
      mist.addColorStop(0, `rgba(255,251,235,${opacity})`);
      mist.addColorStop(.5, `rgba(255,251,239,${opacity * .45})`);
      mist.addColorStop(1, 'rgba(255,253,246,0)');
      context.fillStyle = mist;
      context.fillRect(-radius, -radius, radius * 2, radius * 2);
      context.restore();
    }

    draw() {
      if (!this.isReady()) return;
      const { width, height } = this.canvas;
      const time = this.time * 5.5;
      const context = this.context;
      context.globalAlpha = 1;
      context.globalCompositeOperation = 'source-over';
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      this.cover(context, this.image, width, height,
        1.18 + Math.sin(time * .037) * .025,
        Math.sin(time * .027) * width * .055,
        Math.sin(time * .041 + .7) * height * .04);

      if (!this.cloudLayer) this.cloudLayer = this.prepareCloudLayer();
      if (this.cloudLayer) {
        context.globalAlpha = .22 + Math.sin(time * .063) * .04;
        this.cover(context, this.cloudLayer, width, height,
          1.18 + Math.sin(time * .029 + 1.1) * .03,
          Math.sin(time * .043 + 2) * width * .065,
          Math.cos(time * .031) * height * .045);
        context.globalAlpha = 1;
      }

      // Large translucent mist volumes breathe through the scene, with no wave distortion.
      context.globalCompositeOperation = 'screen';
      this.drawMist(width * (.22 + Math.sin(time * .039) * .18),
        height * (.40 + Math.cos(time * .033) * .12), height * .46, .12, 1.6);
      this.drawMist(width * (.76 + Math.sin(time * .026 + 2) * .16),
        height * (.70 + Math.sin(time * .047) * .10), height * .40, .095, 1.8);
      context.globalCompositeOperation = 'source-over';
      this.classList.add('is-ready');
      this.dataset.cloudFrame = String(++this.frameCount);
    }

    sync() {
      this.stop();
      const running = this.canRun();
      this.dataset.cloudState = running ? 'running'
        : !this.isReady() ? (this.imageFailed || !this.context ? 'unavailable' : 'loading')
          : this.motion.matches ? 'still' : 'paused';
      document.body.classList.toggle('nd-clouds-paused', !running);
      const label = this.motion.matches ? 'Still scene' : this.userPaused ? 'Resume motion' : 'Pause motion';
      for (const button of this.buttons) {
        button.disabled = this.motion.matches;
        button.setAttribute('aria-pressed', String(!running));
        button.setAttribute('aria-label', label);
        const text = button.querySelector('[data-cloud-toggle-label]');
        if (text) text.textContent = label;
      }
      if (running) {
        this.lastFrame = performance.now();
        this.frame = requestAnimationFrame(this.tick);
      }
    }

    stop() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.cloudLayer = null;
      if (!document.querySelector('nd-boutique-clouds')) document.body.classList.remove('nd-clouds-paused');
    }
  }

  customElements.define('nd-boutique-clouds', BoutiqueClouds);
})();

/* The collection turns on a tilted 3D sphere; each piece stays facing the visitor. */
(() => {
  const tau = Math.PI * 2;
  const wrap = angle => ((angle + Math.PI) % tau + tau) % tau - Math.PI;
  const clampPitch = value => Math.max(-1.28, Math.min(1.28, value));
  const spherePoints = count => {
    if (count === 4) {
      // A rotated tetrahedron distributes all four pieces around the sphere, not on one ring.
      const turn = .22;
      return [[0,0,1], [Math.sqrt(8/9),0,-1/3],
        [-Math.sqrt(2/9),Math.sqrt(2/3),-1/3],
        [-Math.sqrt(2/9),-Math.sqrt(2/3),-1/3]].map(([x,y,z]) => ({
          x:x*Math.cos(turn)-y*Math.sin(turn),
          y:x*Math.sin(turn)+y*Math.cos(turn), z
        }));
    }
    if (count === 1) return [{x:0,y:0,z:1}];
    return Array.from({length:count},(_,i) => {
      const y = 1-2*(i+.5)/count;
      const longitude = i*Math.PI*(3-Math.sqrt(5));
      const horizontal = Math.sqrt(1-y*y);
      return {x:Math.sin(longitude)*horizontal,y,z:Math.cos(longitude)*horizontal};
    });
  };

  const setup = root => {
    if (root.dataset.orbitReady) return;
    const track = root.querySelector('[data-gallery-track]');
    const cards = [...(track?.querySelectorAll('.product-card') || [])];
    if (!cards.length) return;
    root.dataset.orbitReady = 'true';
    const controller = new AbortController();
    const options = {signal:controller.signal};
    const content = root.closest('#StoreContent');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const previous = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    const status = root.querySelector('[data-gallery-status]');
    const controls = root.querySelector('[data-gallery-controls]');
    const points = spherePoints(cards.length);
    let yaw = -Math.atan2(points[0].x,points[0].z);
    let pitch = Math.asin(points[0].y);
    let width = 0, height = 0, frame = 0, last = 0, count = 0, index = -1;
    let intersecting = true, focused = false, hovered = false, drag = null, dragged = false;
    let holdUntil = 0, tween = null, suppressClickUntil = 0;
    root.classList.add('nd-orbit-ready');
    if (controls) controls.hidden = cards.length < 2;
    cards.forEach((card,i) => {
      card.setAttribute('role','group');
      card.setAttribute('aria-roledescription','piece');
      card.setAttribute('aria-label',`${card.querySelector('h3')?.textContent.trim() || 'Piece'}, ${i+1} of ${cards.length}`);
      card.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
    });
    const paused = () => motion.matches || document.hidden || content?.hidden || !intersecting
      || document.body.classList.contains('nd-clouds-paused');
    const render = () => {
      const radius = Math.min(width*.28,height*.27);
      const camera = 2.7;
      const roll = -.28;
      const cosYaw = Math.cos(yaw), sinYaw = Math.sin(yaw);
      const cosPitch = Math.cos(pitch), sinPitch = Math.sin(pitch);
      const cosRoll = Math.cos(roll), sinRoll = Math.sin(roll);
      let front = -Infinity, current = 0;
      cards.forEach((card,i) => {
        const point = points[i];
        const x1 = point.x*cosYaw+point.z*sinYaw;
        const z1 = point.z*cosYaw-point.x*sinYaw;
        const y2 = point.y*cosPitch-z1*sinPitch;
        const z = point.y*sinPitch+z1*cosPitch;
        const x = x1*cosRoll-y2*sinRoll;
        const y = x1*sinRoll+y2*cosRoll;
        const projection = camera/(camera-z);
        const depth = (z+1)/2;
        const scale = (camera-1)/(camera-z);
        card.style.transform = `translate(-50%,-50%) translate3d(${(x*radius*projection).toFixed(2)}px,${(-y*radius*projection).toFixed(2)}px,0) scale(${scale.toFixed(4)})`;
        card.style.zIndex = String(Math.round(depth*1000));
        card.style.opacity = '1';
        card.dataset.orbitDepth = depth.toFixed(3);
        card.dataset.sphereX = x.toFixed(3);
        card.dataset.sphereY = y.toFixed(3);
        card.dataset.sphereZ = z.toFixed(3);
        if (z > front) { front=z; current=i; }
      });
      if (index !== current) {
        index = current;
        if (status) status.textContent = `${index+1} / ${cards.length}`;
        cards.forEach((card,i) => card.classList.toggle('is-orbit-front',i === index));
      }
      root.dataset.orbitFrame = String(++count);
      root.dataset.orbitPhase = yaw.toFixed(4);
      root.dataset.sphereYaw = yaw.toFixed(4);
      root.dataset.spherePitch = pitch.toFixed(4);
    };
    const stop = () => { cancelAnimationFrame(frame); frame = 0; last = 0; };
    const tick = now => {
      frame = 0;
      if (paused()) { sync(); return; }
      const elapsed = last ? Math.min(now-last,80)/1000 : 0;
      last = now;
      if (tween) {
        const progress = Math.min(1,(now-tween.start)/1100);
        const eased = 1-Math.pow(1-progress,3);
        yaw = tween.fromYaw+(tween.toYaw-tween.fromYaw)*eased;
        pitch = tween.fromPitch+(tween.toPitch-tween.fromPitch)*eased;
        if (progress === 1) tween = null;
      } else if (!focused && !hovered && !drag && now > holdUntil && cards.length > 1) {
        yaw = (yaw+elapsed*tau/150)%tau;
        // Return gradually to a lightly tilted rotation axis after a visitor spins the globe.
        pitch += (.18-pitch)*Math.min(1,elapsed*.12);
      }
      render();
      frame = requestAnimationFrame(tick);
    };
    const sync = () => {
      stop();
      if (paused()) tween = null;
      root.dataset.orbitState = paused() ? 'paused' : 'running';
      if (!paused()) frame = requestAnimationFrame(tick);
    };
    const go = target => {
      const normalized = ((target%cards.length)+cards.length)%cards.length;
      const point = points[normalized];
      const targetYaw = yaw+wrap(-Math.atan2(point.x,point.z)-yaw);
      const targetPitch = Math.asin(point.y);
      holdUntil = performance.now()+8500;
      if (motion.matches || paused()) {
        yaw=targetYaw; pitch=targetPitch; tween=null; render();
      } else tween = {fromYaw:yaw,toYaw:targetYaw,fromPitch:pitch,toPitch:targetPitch,start:performance.now()};
    };
    previous?.addEventListener('click',() => go(index-1),options);
    next?.addEventListener('click',() => go(index+1),options);
    track.addEventListener('keydown',event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      go(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length-1 : index+(event.key === 'ArrowRight' ? 1 : -1));
    },options);
    root.addEventListener('focusin',event => {
      focused = !event.target.closest('[data-cloud-toggle]');
      const card = event.target.closest('.product-card');
      if (card && !drag && event.target.matches(':focus-visible')) go(cards.indexOf(card));
    },options);
    root.addEventListener('focusout',event => {
      focused = root.contains(event.relatedTarget) && !event.relatedTarget?.closest('[data-cloud-toggle]');
    },options);
    track.addEventListener('pointerenter',event => { if (event.pointerType === 'mouse') hovered=true; },options);
    track.addEventListener('pointerleave',() => { hovered=false; },options);
    track.addEventListener('dragstart',event => event.preventDefault(),options);
    track.addEventListener('pointerdown',event => {
      if (event.button !== 0) return;
      suppressClickUntil = 0;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      drag = {id:event.pointerId,x:event.clientX,y:event.clientY,yaw,pitch,touch:event.pointerType === 'touch'};
      dragged = false;
      tween = null;
    },options);
    track.addEventListener('pointermove',event => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX-drag.x, dy = event.clientY-drag.y;
      if (!dragged && Math.hypot(dx,dy) < 8) return;
      // Vertical touch gestures remain native page scrolling; mouse/pen can tilt both axes.
      if (!dragged && drag.touch && Math.abs(dy) > Math.abs(dx)) { drag=null; return; }
      dragged = true;
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
      yaw = drag.yaw+dx/Math.max(width*.68,240)*Math.PI;
      if (!drag.touch) pitch=clampPitch(drag.pitch+dy/Math.max(height*.9,300)*Math.PI);
      render();
    },options);
    const endDrag = event => {
      if (!drag || event.pointerId !== drag.id) return;
      drag = null;
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      track.classList.remove('is-dragging');
      if (dragged) {
        holdUntil = performance.now()+8500;
        suppressClickUntil=performance.now()+500;
        dragged=false;
      }
    };
    track.addEventListener('pointerup',endDrag,options);
    track.addEventListener('pointercancel',endDrag,options);
    track.addEventListener('lostpointercapture',endDrag,options);
    document.addEventListener('pointerup',endDrag,options);
    document.addEventListener('pointercancel',endDrag,options);
    track.addEventListener('click',event => {
      if (event.detail !== 0 && (dragged || performance.now() < suppressClickUntil)) {
        event.preventDefault(); event.stopPropagation(); suppressClickUntil=0;
      }
    },{...options,capture:true});
    motion.addEventListener('change',() => { tween=null; sync(); },options);
    document.addEventListener('visibilitychange',sync,options);
    window.addEventListener('pagehide',stop,options);
    window.addEventListener('pageshow',sync,options);
    const resize = new ResizeObserver(() => {
      width=track.clientWidth; height=track.clientHeight; render();
    });
    resize.observe(track);
    const visibility = new MutationObserver(sync);
    visibility.observe(document.body,{attributes:true,attributeFilter:['class']});
    if (content) visibility.observe(content,{attributes:true,attributeFilter:['hidden']});
    const intersection = new IntersectionObserver(entries => { intersecting=entries.some(e=>e.isIntersecting); sync(); });
    intersection.observe(root);
    document.addEventListener('shopify:section:unload',event => {
      if (!event.target.contains(root)) return;
      stop(); controller.abort(); resize.disconnect(); visibility.disconnect(); intersection.disconnect();
      delete root.dataset.orbitReady;
    },options);
    width=track.clientWidth; height=track.clientHeight;
    render(); sync();
  };
  document.querySelectorAll('[data-orbit-gallery]').forEach(setup);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-orbit-gallery]').forEach(setup));
})();
